export default __webpack_public_path__ + "static/media/024-train.11fac08e.svg";